import BufferOp from 'jsts/org/locationtech/jts/operation/buffer/BufferOp';
import Polygon from 'jsts/org/locationtech/jts/geom/Polygon';
import GeometryFactory from 'jsts/org/locationtech/jts/geom/GeometryFactory';
import MultiPolygon from 'jsts/org/locationtech/jts/geom/MultiPolygon';
import {
  MultiPolygon2,
  MultiPolygon2Result,
  ResultType,
} from '../../geometric-types';
import { toJstsMultiPolygon, toMultiPolygon2 } from '../util/polygon';

export function calculateSheetShapeFireSectioning(
  multiPolygonInput: MultiPolygon2,
  buffer: number
): MultiPolygon2Result {
  const jstsMultiPolygon = toJstsMultiPolygon(multiPolygonInput);

  const bufferedIntersectionPolygon = BufferOp.bufferOp(
    jstsMultiPolygon,
    buffer,
    0
  );

  let resultMultiPolygon;
  if (bufferedIntersectionPolygon instanceof MultiPolygon) {
    resultMultiPolygon = bufferedIntersectionPolygon;
  } else if (bufferedIntersectionPolygon instanceof Polygon) {
    // If the result is a single Polygon, wrap it in a MultiPolygon
    const factory = new GeometryFactory();
    resultMultiPolygon = factory.createMultiPolygon([
      bufferedIntersectionPolygon,
    ]);
  }
  if (resultMultiPolygon) {
    const value = resultMultiPolygon.getArea();
    const multiPolygon = toMultiPolygon2(resultMultiPolygon);

    return {
      type: ResultType.MULTIPOLYGON2,
      value,
      multiPolygon: multiPolygon,
    };
  } else {
    throw new Error('resultMultiPolygon is undefined');
  }
}
